import { useEffect, type KeyboardEvent, type RefObject } from "react";

export function useConfirmDialogFocus(
  cancelRef: RefObject<HTMLButtonElement | null>,
  confirmRef: RefObject<HTMLButtonElement | null>,
  onCancel: () => void,
  fallbackFocusRef?: RefObject<HTMLElement | null>
) {
  useEffect(() => {
    const previouslyFocused = document.activeElement as HTMLElement | null;
    cancelRef.current?.focus();

    return () => {
      if (previouslyFocused && document.contains(previouslyFocused)) {
        previouslyFocused.focus();
      } else {
        fallbackFocusRef?.current?.focus();
      }
    };
  }, [fallbackFocusRef]);

  return (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();
      onCancel();
      return;
    }

    if (e.key === "Tab") {
      if (e.shiftKey && document.activeElement === cancelRef.current) {
        e.preventDefault();
        confirmRef.current?.focus();
      } else if (!e.shiftKey && document.activeElement === confirmRef.current) {
        e.preventDefault();
        cancelRef.current?.focus();
      }
    }
  };
}
